import React from "react";
import styled from "@emotion/styled";

const MessageContainer = styled.div`
  width: 100%;
  height: 61px;
  border-radius: 10px;
  background-color: rgba(119, 121, 132, 0.1);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  color: #1f2021;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  padding-left: 30px;

  @media (max-width: 550px) {
    font-size: 13px;
    height: auto;
    padding: 10px;
    text-align: center;
  }
  @media (max-width: 450px) {
    font-size: 12px;
  }
`;

const CategoryMessageContainer = ({ message }) => (
  <MessageContainer>{message}</MessageContainer>
);
export default CategoryMessageContainer;
